var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item"},[_c('LoginForm'),_vm._v(" Sign in page ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }